import React, { useState } from "react";
import clsx from "clsx";
import { getIconPath } from "@/utils/helpers";
import { useTheme } from "@mui/material";
import styles from "./Card.module.scss";

const CustomTooltip = ({ children, text }: { children: React.ReactNode; text: string; }) => {
    const [isHovering, setIsHovering] = useState(false);
    return (
        <div className={styles.tooltip}>
            {isHovering && (
                <div
                    className={clsx(styles.content, {
                        [styles.visible]: isHovering,
                    })}>
                    <img
                        src={getIconPath({
                            name: `/analytics/info_light`,
                        })}
                        className={styles.infoIcon}
                        alt="Info icon"
                        width={12}
                        height={12}
                    />
                    <span>{text}</span>
                </div>
            )}
            <div onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
                {children}
            </div>
        </div>
    );
};

export const Card = ({
    title,
    timestamp,
    withInfoIcon = true,
    tooltipText = "",
    children,
}: {
    title: string;
    tooltipText?: string;
    timestamp?: string;
    withInfoIcon?: boolean;
    children: React.ReactNode;
}) => {
    const { palette } = useTheme();

    return (
        <div className={styles.card}>
            <div
                className={clsx(styles.title, {
                    [styles.withDatetime]: !!timestamp,
                })}>
                {withInfoIcon && (
                    <CustomTooltip text={tooltipText || title}>
                        <img
                            src={getIconPath({
                                name: `/analytics/info${palette.mode === "dark" ? "_light" : ""}`,
                            })}
                            className={styles.infoIcon}
                            alt="Info icon"
                            width={12}
                            height={12}
                        />
                    </CustomTooltip>
                )}
                <span>{title}</span>
            </div>
            {timestamp && <span className={styles.datetime}>{timestamp}</span>}
            {children}
        </div>
    );
};
